import React from 'react';

export default function AntTableBody({ children }) {
  return (
    <tbody className="ant-table-tbody">
      {children}
    </tbody>
  );
}
